import dayjs from "dayjs";
import { UserRole } from "types/user";

const PASSWORD_EXPIRY_DAYS = 183;

const ROLES_REQUIRING_ROTATION = new Set<UserRole>([
  UserRole.ROLE_SYSTEM_ADMIN,
  UserRole.ROLE_ORGANIZER_ADMIN,
  UserRole.ROLE_ORGANIZER_EMPLOYEE,
  UserRole.ROLE_HEALTHCARE_ADMIN,
  UserRole.ROLE_HEALTHCARE_EMPLOYEE,
  UserRole.ROLE_HYGIENE_INSTITUTION_USER,
  UserRole.ROLE_QUESTIONNAIRE_DEVELOPER_USER,
  UserRole.ROLE_EVALUATOR_USER,
  UserRole.ROLE_CONTROLLING_AUTHORITY_USER,
  UserRole.ROLE_ANALYST_USER,
]);

export const isPasswordRotationRequired = (role: UserRole): boolean =>
  ROLES_REQUIRING_ROTATION.has(role);

export const isPasswordExpired = (passwordChangedAt: string | null): boolean => {
  if (!passwordChangedAt) return true;
  return dayjs().diff(dayjs(passwordChangedAt), "day") >= PASSWORD_EXPIRY_DAYS;
};
